import { Badge } from '@/components/ui/badge';
import { CheckCircle, AlertTriangle, XCircle } from 'lucide-react';
import { useState } from 'react';

interface HealthCheckBadgeProps {
  score: number;
  onClick?: () => void;
}

export const HealthCheckBadge = ({ score, onClick }: HealthCheckBadgeProps) => {
  const [hovered, setHovered] = useState(false);

  const getStyle = () => {
    const isHover = hovered;
    if (score >= 90) return { backgroundColor: `var(--success-${isHover ? '600' : '500'})` };
    if (score >= 50) return { backgroundColor: `var(--warning-${isHover ? '600' : '500'})` };
    return {};
  };

  const getIcon = () => {
    if (score >= 90) return <CheckCircle className="h-3.5 w-3.5" />;
    if (score >= 50) return <AlertTriangle className="h-3.5 w-3.5" />;
    return <XCircle className="h-3.5 w-3.5" />;
  };

  const getLabel = () => {
    if (score >= 90) return 'Excellent';
    if (score >= 70) return 'Good';
    if (score >= 50) return 'Fair';
    return 'Needs Attention';
  };

  const isDestructive = score < 50;

  return (
    <Badge
      className={`text-white px-3 py-1.5 text-sm font-medium cursor-pointer transition-colors ${isDestructive ? 'bg-destructive hover:bg-destructive/90' : ''}`}
      style={isDestructive ? undefined : getStyle()}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span className="flex items-center gap-2">
        {getIcon()}
        <span>Health: {score}/100</span>
        <span className="opacity-80">({getLabel()})</span>
      </span>
    </Badge>
  );
};
